import React from "react";
import { useSelector } from "react-redux";
import "../../src/assets/Styles/theme.scss";

function ProfileInfo() {
  const user = useSelector((state) => state.fetchUser?.user);
  const userImg = useSelector((state) => state.fetchUser?.user?.profileImg);
  const userName = useSelector((state) => state.fetchUser?.user?.name);
  const userBio = useSelector((state) => state.fetchUser?.user?.bio);

  const defaultImageUrl = process.env.REACT_APP_S3_URL || "/assets/images/defultprofileimage.png";

  const imageUrl = userImg && userImg.includes("https://hello-image-bucket.s3")
      ? userImg
      : defaultImageUrl + userImg;

  return (
    <div className="Profile_details">
      <figure>
        <img
          src={imageUrl}
          alt="User Profile"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = defaultImageUrl;
          }}
        />
      </figure>
      <div className="main-details">
        <h4 className="headingfonts">{userName || "Unnamed User"}</h4>
        <p className="description">{userBio || "No bio available."}</p>
      </div>
      <div className="follower-reviews">
        <p>{/* e.g., 2k Followers • 250 Reviews */}</p>
      </div>
    </div>
  );
}

export default ProfileInfo;
